module.exports = __webpack_public_path__ + "img/KeksAufessen.49cb46ee.svg";